/**
 * クライアント登録
 */

import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {
    Grid,
    InputLabel,
    Button,
    DialogTitle
} from '@material-ui/core';
import {dictionary} from 'mdoc/admin/axios'
import * as config from 'mdoc/admin/axios/config'
import {addClient,updateClient} from 'mdoc/admin/axios/client'
import {ByteFormatToGB} from 'mdoc/utils';
import Toast from 'mdoc/utils/toast';
import Dialog from 'mdoc/utils/myDialog';

import eventProxy from 'mdoc/utils/eventProxy'
import {clientsInfo} from 'mdoc/admin/axios';

const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit,
    },
    bootstrapRoot: {
        'label + &': {
            marginTop: theme.spacing.unit * 3,
        }
    },
    bootstrapInput: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '5px 6px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    bootstrapFormLabel: {
        lineHeight: '30px',
    },
    bootstrapSelect: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da!important',
        paddingLeft: '5px'
    },
    Radio: {
        padding: '0px 10px'
    },
    required: {
        color: '#F72D2D'
    },
    button: {
        margin: theme.spacing.unit
    },
    addButton: {
        margin: theme.spacing.unit,
        borderRadius: '50%'
    },
    errorMsg: {},
    spanBox:{
        lineHeight:'30px'
    },
    title:{
        marginLeft:'-20px'
    }
});

class Client_Confirm extends React.Component {
    state = {
        selectedRowKeys: [], // Check here to configure the default column
        formData: {
            clientCode: {
                value: '',
                error: false,
                errorMsg: ''
            },
            name: {
                value: '',
                error: false,
                errorMsg: ''
            },
            contactName: {
                value: '',
                error: false,
                errorMsg: ''
            },
            contactEmail: {
                value: '',
                error: false,
                errorMsg: ''
            },
            phone: {
                value: '',
                error: false,
                errorMsg: ''
            },
            fax: {
                value: '',
                error: false,
                errorMsg: ''
            },
            zipCode: {
                value: '',
                error: false,
                errorMsg: ''
            },
            address: {
                value: '',
                error: false,
                errorMsg: ''
            },
            capacity: {
                value: '',
                error: false,
                errorMsg: ''
            },
            startTimeStr: {
                value: '',
                error: false,
                errorMsg: ''
            },
            endTimeStr: {
                value: '',
                error: false,
                errorMsg: ''
            },
            managerCreate: {
                ruleId: config['RULE_CODE']['managerCreate'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            managerCreateNum: {
                value: '',
                error: false,
                errorMsg: ''
            },
            deputyManagerCreate: {
                ruleId: config['RULE_CODE']['deputyManagerCreate'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            deputyManagerCreateNum: {
                value: '',
                error: false,
                errorMsg: ''
            },
            userCreate: {
                ruleId: config['RULE_CODE']['userCreate'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            userCreateNum: {
                value: '',
                error: false,
                errorMsg: ''
            },
            departmentManagementAuth: {
                ruleId: config['RULE_CODE']['departmentManagementAuth'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            categoryManagementAuth: {
                ruleId: config['RULE_CODE']['categoryManagementAuth'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            newsRelease: {
                ruleId: config['RULE_CODE']['newsRelease'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            pushNotice: {
                ruleId: config['RULE_CODE']['pushNotice'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            contentRegistrationAuth: {
                ruleId: config['RULE_CODE']['contentRegistrationAuth'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            deviceControl: {
                ruleId: config['RULE_CODE']['deviceControl'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            contentMultipleRegistration: {
                ruleId: config['RULE_CODE']['contentMultipleRegistration'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            applicationImport: {
                ruleId: config['RULE_CODE']['applicationImport'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            activeDirectory: {
                ruleId: config['RULE_CODE']['activeDirectorySetting'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            contentUpdateEmailDelivery: {
                ruleId: config['RULE_CODE']['contentUpdateEmailDelivery'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            contentUpdatePushDelivery: {
                ruleId: config['RULE_CODE']['contentUpdatePushDelivery'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            logExport: {
                ruleId: config['RULE_CODE']['logExport'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            loginKeepTimeFlg: {
                width: '',
                value: '',
                error: false,
                errorMsg: ''
            },
            userLoginKeepTimeFlg: {
                width: '',
                value: '',
                error: false,
                errorMsg: ''
            },
            adminUserCode: {
                value: '',
                error: false,
                errorMsg: ''
            },
            contactPersonName: {
                value: '',
                error: false,
                errorMsg: ''
            },
            email: {
                value: '',
                error: false,
                errorMsg: ''
            },
            langId: {
                width: '',
                value: '',
            },
            langName: {
                width: '',
                value: '',
            },
            contactLangId:{
                width: '',
                value: '',
            },
            contactLangName:{
                width: '',
                value: '',
            },
            passValidTimeFlg:{
                width: '',
                value: '0',
                error: false,
                errorMsg: ''
            },
            userPassValidTimeFlg:{
                width: '',
                value: '0',
                error: false,
                errorMsg: ''
            },
        },
        // loading: false,
        dictWord: {
            'company_name': '',
            'contact_name': '',
            'contact_email': '',
            'tel_no': '',
            'fax_no': '',
            'zip_code': '',
            'address': '',
            'use_capacity': '',
            'service_start_date': '',
            'service_end_date': '',
            'enterprise_managers_generate': '',
            'enterprise_managers_count': '',
            'associate_managers_generate': '',
            'associate_managers_count': '',
            'user_generate': '',
            'user_count': '',
            'department_management_auth': '',
            'category_management_auth': '',
            'notification_release': '',
            'push_notice': '',
            'content_registration_auth': '',
            'device_control': '',
            'content_multiple_registration': '',
            'log_export': '',
            'login_save_period': '',
            'enterprise_managers_registration': '',
            'enterprise_managers_id': '',
            'contact_person_name': '',
            'email': '',
            'cancel': '',
            'msg_error_not_null_with_item': '',
            'msg_error_over_length_with_item': '',
            'valid': '',
            'invalid': '',
            'indefinitely': '',
            '3_months': '',
            '6_months': '',
            '12_months': '',
            '1_day': '',
            '1_week': '',
            '1_months': '',
            'yes': '',
            'msg_warning_content': '',
            'return': '',
            'msg_confirm_delete_input_content': '',
            'confirmation': '',
            'set_lang': '',
            'contact_set_lang': '',
            'msg_register_this_content': '',
            'application_import': '',
            'active_directory_setting':'',
            'content_update_email_delivery':'',
            'content_update_push_delivery':'',
            'group_id':'',
            'managers_password_expires_period':'',
            'user_password_expires_period':'',
            'managers_login_save_period':'',
            'user_login_save_period':''
        },
        loginKeepTimeFlg: config['LOGIN_KEEP_TIME'],
        userLoginKeepTimeFlg: config['LOGIN_KEEP_TIME'],
        passValidTimeFlg: config['PASS_VALID_TIME_FLG'],
        userPassValidTimeFlg: config['USER_PASS_VALID_TIME_FLG'],
        valid: config['VALID'],
        confirmData: {},
        dialogOpen:false,
        dialogCancelOpen:false,
        dialogMessage:'',
		okLoading: false
    };
    componentWillMount() {
        this.start();
    }

    componentDidMount() {
        let formData = this.state.formData;
        if (this.props.location.query !== undefined) {
            const confirmData = this.props.location.query;
            this.setState({
                confirmData: confirmData
            });
            for (let index in formData) {
                let value = confirmData[index];
                formData[index] = Object.assign(this.state['formData'][index], {value: value});
            }
        } else {
            let pathname = '/admin/management/client_detail';
            if (this.props.match.params.id !== undefined) {
                pathname += '/'+this.props.match.params.id;
            }
            this.props.history.replace({
                pathname: pathname,
            })
        }
        this.setState({
            formData: formData
        });
    }
    start = () => {
        let dict = {}
        dictionary(this.state.dictWord).then(res => {
            res.map(val => {
                dict[val.dictKey] = val.dictValue;
                return val;
            })
            this.setState({
                dictWord: dict,
            })
        })
    }
    handleSubmit = () => {
        const confirmData = this.state.confirmData;
        this.setState({
            dialogOpen:true,
            dialogMessage:confirmData.id?this.state.dictWord['msg_register_this_content']:this.state.dictWord['msg_warning_content']
        });
    }
    dialogHandleOK = ()=>{
        const confirmData = this.state.confirmData;
		this.setState({
            okLoading: true
          });
        if(confirmData.id){
            updateClient(confirmData).then(res => {            
                this.props.history.push('/admin/management/client');
            }).catch(function (error) {
                Toast.error(error);
            })
        }else{
            addClient(confirmData).then(res => {
                clientsInfo().then(res => {
                    eventProxy.trigger('msg', res)
                }).catch(function (err) {
                    Toast.error(err);
                })
                
                this.props.history.push('/admin/management/client');
            }).catch(function (error) {
                Toast.error(error);
            })
        }
    }
    dialogHandleClose = ()=>{
        this.setState({
            dialogOpen:false
        });
    }
    handleReturn = ()=>{
        const confirmData = this.state.confirmData;
        let pathname = '/admin/management/client_detail';
        if (this.props.match.params.id !== undefined) {
            pathname += '/'+this.props.match.params.id;
        }
        this.props.history.push({
            pathname: pathname,
            query: confirmData
        })
    }

    handleCancel = ()=>{
        this.setState({
            dialogCancelOpen:true
        });
    }
    dialogHandleYes = () =>{
        this.props.history.push({
            pathname: '/admin/management/client',
        })
    }
    dialogHandleCancel = () =>{
        this.setState({
            dialogCancelOpen:false
        });
    }
    render() {
        const {classes} = this.props;
        const {dictWord} = this.state;
        return (
            <div className="mainDom">
                <div className={classes.appBarSpacer} />
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="clientCode">
                            {dictWord.group_id}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {this.state.formData.clientCode.value}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="name">
                            {dictWord.company_name}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {this.state.formData.name.value}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contactName">
                            {dictWord.contact_name}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {this.state.formData.contactName.value}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contactEmail">
                            {dictWord.contact_email}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {this.state.formData.contactEmail.value}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contactLangId">
                            {dictWord.contact_set_lang}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {this.state.formData.contactLangName.value}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="phone">
                            {dictWord.tel_no}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {this.state.formData.phone.value}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="fax">
                            {dictWord.fax_no}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {this.state.formData.fax.value}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="zipCode">
                            {dictWord.zip_code}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {this.state.formData.zipCode.value}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="address">
                            {dictWord.address}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {this.state.formData.address.value}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="capacity">
                            {dictWord.use_capacity}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {ByteFormatToGB(this.state.formData.capacity.value)} GB
                        </span>
                    </Grid>
                </Grid>

                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="startTimeStr">
                            {dictWord.service_start_date}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {this.state.formData.startTimeStr.value?this.state.formData.startTimeStr.value:''}
                        </span>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="endTimeStr">
                            {dictWord.service_end_date}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {this.state.formData.endTimeStr.value?this.state.formData.endTimeStr.value:''}
                        </span>
                    </Grid>
                </Grid>

                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="managerCreate-input">
                            {dictWord.enterprise_managers_generate}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.managerCreate.value]]}
                        </span>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="managerCreateNum">
                            {dictWord.enterprise_managers_count}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {this.state.formData.managerCreateNum.value}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="deputyManagerCreate">
                            {dictWord.associate_managers_generate}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.deputyManagerCreate.value]]}
                        </span>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="deputyManagerCreateNum">
                            {dictWord.associate_managers_count}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {this.state.formData.deputyManagerCreateNum.value}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="userCreate">
                            {dictWord.user_generate}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.userCreate.value]]}
                        </span>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="userCreateNum">
                            {dictWord.user_count}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {this.state.formData.userCreateNum.value}
                        </span>
                    </Grid>
                </Grid>

                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="departmentManagementAuth">
                            {dictWord.department_management_auth}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.departmentManagementAuth.value]]}
                        </span>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="categoryManagementAuth">
                            {dictWord.category_management_auth}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.categoryManagementAuth.value]]}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="newsRelease">
                            {dictWord.notification_release}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.newsRelease.value]]}
                        </span>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="pushNotice">
                            {dictWord.push_notice}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.pushNotice.value]]}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contentRegistrationAuth">
                            {dictWord.content_registration_auth}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.contentRegistrationAuth.value]]}
                        </span>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="deviceControl">
                            {dictWord.device_control}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.deviceControl.value]]}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contentMultipleRegistration">
                            {dictWord.content_multiple_registration}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.contentMultipleRegistration.value]]}
                        </span>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="logExport">
                            {dictWord.log_export}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.logExport.value]]}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="applicationImport">
                            {dictWord.application_import}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.applicationImport.value]]}
                        </span>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="activeDirectory">
                            {dictWord.active_directory_setting}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.activeDirectory.value]]}
                        </span>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contentUpdateEmailDelivery">
                            {dictWord.content_update_email_delivery}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.contentUpdateEmailDelivery.value]]}
                        </span>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contentUpdatePushDelivery">
                            {dictWord.content_update_push_delivery}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.valid[this.state.formData.contentUpdatePushDelivery.value]]}
                        </span>
                    </Grid>
                </Grid>

                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="passValidTimeFlg">
                            {dictWord.managers_password_expires_period}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.passValidTimeFlg[this.state.formData.passValidTimeFlg.value]]}
                        </span>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="loginKeepTimeFlg">
                            {dictWord.managers_login_save_period}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.loginKeepTimeFlg[this.state.formData.loginKeepTimeFlg.value]]}
                        </span>
                    </Grid>
                </Grid>

                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="userPassValidTimeFlg">
                            {dictWord.user_password_expires_period}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.userPassValidTimeFlg[this.state.formData.userPassValidTimeFlg.value]]}
                        </span>
                    </Grid>

                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="userLoginKeepTimeFlg">
                            {dictWord.user_login_save_period}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <span className={classes.spanBox}>
                            {dictWord[this.state.userLoginKeepTimeFlg[this.state.formData.userLoginKeepTimeFlg.value]]}
                        </span>
                    </Grid>
                </Grid>

                <Grid container className={classes.margin}>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="adminUserCode">
                                {dictWord.enterprise_managers_id}<span className={classes.required}>*</span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {this.state.formData.adminUserCode.value}
                        </span>
                        </Grid>
                    </Grid>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="contactPersonName">
                                {dictWord.contact_person_name}<span className={classes.required}>*</span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {this.state.formData.contactPersonName.value}
                        </span>
                        </Grid>
                    </Grid>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="email">
                                {dictWord.email}<span className={classes.required}>*</span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {this.state.formData.email.value}
                        </span>
                        </Grid>
                    </Grid>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="langId">
                                {dictWord.set_lang}<span className={classes.required}>*</span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={4}>
                        <span className={classes.spanBox}>
                            {this.state.formData.langName.value}
                        </span>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container id="buttonNode" className={classes.margin}>
                    <Grid item xs={12} md={12} className={classes.bootstrapFormLabel}>
                        <Button variant="contained" color="primary" onClick={this.handleSubmit} className={classes.button}>{dictWord.confirmation}</Button>
                        <Button variant="contained" color="primary" className={classes.button} onClick={this.handleReturn}>{dictWord.return}</Button>
                        <Button variant="contained" color="primary" className={classes.button} onClick={this.handleCancel}>{dictWord.cancel}</Button>
                    </Grid>
                </Grid>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        ok:{
                            text:dictWord['yes'],
                        },
                        close:{
                            text:dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{this.state.dialogMessage}</p>
                    }
					okLoading={this.state.okLoading}
                    handleOk={this.dialogHandleOK}
                    handleClose={this.dialogHandleClose}
                />
                <Dialog
                    open={this.state.dialogCancelOpen}
                    option={{
                        ok:{
                            text:dictWord['yes'],
                        },
                        close:{
                            text:dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{dictWord['msg_confirm_delete_input_content']}</p>
                    }
                    handleOk={this.dialogHandleYes}
                    handleClose={this.dialogHandleCancel}
                />
            </div>
        )
    }
}

Client_Confirm.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Client_Confirm);
